const progress = {
  baseStyle: {
    track: { bg: "rgba(35, 78, 112, 0.14)", _dark: { bg: "accent-subtle" } },
    filledTrack: { bg: "primary" },
  },
};

export default progress;
